import React, { Fragment, useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import { Badge } from "react-bootstrap";

import { useAuth } from "../../../context/AuthContext";
import { db } from "../../../firebase";
import {
  query,
  where,
  getDoc,
  updateDoc,
  doc,
  collection,
  getDocs,
  setDoc,
} from "firebase/firestore";

import { notifyTopRight, notifyWarning, notifyError } from "../toast/SetToast";
import Toast from "../toast/SetToast";
import { startAddOrder } from "../../../actions/orders";
import { startEditCpap } from "../../../actions/cpaps";
import selectCpaps from "../../../selectors/cpaps";
import { OrderForm } from "./OrderForm";
import { startAddNote } from "../../../actions/notes";
import { OrderEditForm } from "./OrderEditForm";
import {
  calculateWarrantyEndDate,
  DEFAULT_WARRANTY_PERIOD,
  isSupportedWarrantyPeriod,
  toWarrantyDate,
} from "./warrantyUtils";

const ProductOrderRegister = (props) => {
  const { currentUser } = useAuth();
  const [isPurchase, setIsPurchase] = useState(false);
  const [saleOrderNumber, setSaleOrderNumber] = useState();
  const [patient, setPatient] = useState();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileNames, setFilenames] = useState([]);
  const [doctorOptions, setDoctorOptions] = useState([]);
  const { id, sn, dn } = useParams();

  const initialWarrantyDate = new Date();
  const [startDate, setStartDate] = useState(initialWarrantyDate);
  const [endDate, setEndDate] = useState(() =>
    calculateWarrantyEndDate(DEFAULT_WARRANTY_PERIOD, initialWarrantyDate),
  );
  const [receiptDate, setReceiptDate] = useState(initialWarrantyDate);

  const orderStatuses = [
    {
      status: "เตรียมเครื่อง",
      variant: "primary light",
      detail: "กำลังเตรียมเครื่องและเอกสาร",
    },
    {
      status: "กำลังดำเนินการ",
      variant: "warning light",
      detail: "กำลังดำเนินการจัดส่ง",
    },
    {
      status: "รอเอกสาร",
      variant: "info light",
      detail: "รอเอกสารหลังการจัดส่ง",
    },
    {
      status: "เสร็จสิ้น",
      variant: "success light",
      detail: "คำสั่งซื้อเสร็จสิ้นเรียบร้อยแล้ว",
    },
    { status: "ยกเลิก", variant: "danger dark", detail: "คำสั่งซื้อถูกยกเลิก" },
  ];

  const inputRef = useRef({
    // receiptNo: "",
    hn: "",
    amount: "",
    salePackage: "",
    mask: "",
    maskSize: "",
    receiptDate: "",
    refHospital: "",
    refPhysician: "",
    note: "",
    status: null,
    activity: null,
    warrantyPeriod: DEFAULT_WARRANTY_PERIOD,
    warrantyStartDate: null,
    warrantyEndDate: null,
    sales: null,
  });

  async function getNextSequence() {
    const sequenceRef = doc(db, "sequenceTracker", "saleOrderSequence");

    try {
      const sequenceDoc = await getDoc(sequenceRef);

      if (!sequenceDoc.exists()) {
        throw new Error("Sequence document does not exist!");
      }

      const data = sequenceDoc.data();

      const currentMonth = data.month;

      const currentYear = data.year;

      await setDoc(sequenceRef, {
        current: data.current,
        month: currentMonth,
        year: currentYear,
      });

      // Get the current sequence
      const current = data.current;
      return current.toString().padStart(3, "0");
    } catch (e) {
      console.error("Failed to get sequence: ", e);
      throw e;
    }
  }

  async function updateSequence(newSequence) {
    const sequenceRef = doc(db, "sequenceTracker", "saleOrderSequence");

    try {
      await updateDoc(sequenceRef, { current: newSequence });
    } catch (e) {
      console.error("Failed to update sequence: ", e);
      throw e;
    }
  }

  const generateId = async () => {
    // const currentDate = new Date();
    // const thaiYear = currentDate.getFullYear() + 543;
    // const year = thaiYear.toString().slice(-2);
    // const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");

    const sequenceRef = doc(db, "sequenceTracker", "saleOrderSequence");
    const sequenceDoc = await getDoc(sequenceRef);
    const data = sequenceDoc.data();

    const year = data.year.toString().slice(2);
    const month = data.month;

    const sequence = await getNextSequence();

    return `IGC${year}${month}${sequence}`;
  };

  const updateWarrantyDates = (period, warrantyStartDate) => {
    if (!isSupportedWarrantyPeriod(period)) return;

    const nextStartDate = toWarrantyDate(warrantyStartDate);
    const nextEndDate = calculateWarrantyEndDate(period, nextStartDate);
    if (!nextStartDate || !nextEndDate) return;

    setStartDate(nextStartDate);
    setEndDate(nextEndDate);
  };

  const handleChange = (name) => (e) => {
    if (name === "nationalImage") {
      for (let i = 0; i < e.target.files.length; i++) {
        const f = e.target.files[i];
        setSelectedFiles((prevState) => [...prevState, f]);
        setFilenames((prevState) => [...prevState, f.name]);
        console.log(f.name);
      }
    } else if (name === "warrantyPeriod") {
      inputRef.current[name] = e.target.value;
      updateWarrantyDates(e.target.value, startDate || receiptDate);
    } else if (name === "receiptDate") {
      const nextReceiptDate = toWarrantyDate(e.target.value);
      setReceiptDate(nextReceiptDate || e.target.value);
      inputRef.current[name] = e.target.value;
      updateWarrantyDates(
        inputRef.current.warrantyPeriod || DEFAULT_WARRANTY_PERIOD,
        nextReceiptDate,
      );
    } else if (name === "warrantyStartDate") {
      inputRef.current[name] = e.target.value;
      updateWarrantyDates(
        inputRef.current.warrantyPeriod || DEFAULT_WARRANTY_PERIOD,
        e.target.value,
      );
    } else {
      inputRef.current[name] = e.target.value;
    }
    // console.log(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const ref = doc(db, "patients", inputRef.current.hn);
    const docSnap = await getDoc(ref);
    if (docSnap.exists()) {
      //check if purchase order already created
      const orderQuery = query(
        collection(db, "orders"),
        where("productSn", "==", sn),
        where("activity", "==", "purchase")
      );

      const orderReceiptQuery = query(
        collection(db, "orders"),
        where("receiptNo", "==", saleOrderNumber),
        where("activity", "==", "purchase")
      );

      const orderDoc = await getDocs(orderQuery);
      const orderReceiptDoc = await getDocs(orderReceiptQuery);
      if (!orderDoc.empty) {
        if (inputRef.current.activity === "purchase") {
          notifyError(
            "Purchase order already created, Re-create please delete the old purchase order"
          );
          return;
        }
      } else if (!orderReceiptDoc.empty) {
        notifyError("Sale order number already used, Re-create please delete the old receipt order");
        return;
      }

      getPatient(inputRef.current.hn);

      // console.log("patient", patient);

      const formData = {
        // receiptNo: inputRef.current.receiptNo,
        receiptNo: saleOrderNumber,
        hn: inputRef.current.hn,
        amount: inputRef.current.amount,

        salePackage: inputRef.current.salePackage,
        mask: inputRef.current.mask,
        maskSize: inputRef.current.maskSize,

        receiptDate: inputRef.current.receiptDate
          ? new Date(inputRef.current.receiptDate)
          : new Date(receiptDate),
        // receiptDate: inputRef.current.receiptDate
        //   ? new Date(inputRef.current.receiptDate)
        //   : null,
        // refHospital: inputRef.current.refHospital,
        refHospital: docSnap.data().refHn,
        refPhysician: inputRef.current.refPhysician,
        sales: inputRef.current.sales,
        note: inputRef.current.note,
        productId: id,
        productSn: sn,
        deviceNo: dn,
        status: inputRef.current.status,
        activity: inputRef.current.activity,
        createdBy: currentUser.displayName,
        warrantyPeriod: inputRef.current.warrantyPeriod,
        warrantyStartDate: endDate
          ? startDate
          : new Date(inputRef.current.warrantyStartDate),

        // warrantyStartDate: inputRef.current.warrantyStartDate
        //   ? new Date(inputRef.current.warrantyStartDate)
        //   : null,
        warrantyEndDate: endDate
          ? endDate
          : new Date(inputRef.current.warrantyEndDate),
        // warrantyEndDate: inputRef.current.warrantyEndDate
        //   ? new Date(inputRef.current.warrantyEndDate)
        //   : null,
        createdAt: new Date(),
        updatedAt: new Date(),
        firstname: docSnap.data().firstnameTh,
        lastname: docSnap.data().lastnameTh,
        nodeRef:
          docSnap.data().nodeRef === undefined ? "" : docSnap.data().nodeRef,
        refCustomer:
          docSnap.data().refCustomer === undefined
            ? ""
            : docSnap.data().refCustomer,
        mobile: docSnap.data().mobile,
        address: docSnap.data().address1,
      };

      if (fileNames.length > 0) {
        props.startAddNote(
          {
            title: "National ID Card",
            detail: "",
            filename: fileNames,
            hn: inputRef.current.hn,
            createBy: currentUser.displayName,
            updateAt: new Date(),
            createAt: new Date(),
          },
          selectedFiles
        );
      }

      console.log("formData", formData);

      props
        .startAddOrder(formData)
        .then(() => notifyTopRight("บันทึกข้อมูลสำเร็จ"))
        .catch((err) => {
          notifyError("บันทึกข้อมูลผิดพลาด ", err);
        });

      // update status "ขาย"
      const docRef = doc(db, "products", id);
      await updateDoc(docRef, { status: "ขาย", sales: formData.sales });

      // update next sale order number
      const currentSequence = await getNextSequence();
      const newSequence = parseInt(currentSequence, 10) + 1;
      await updateSequence(newSequence);
    } else {
      notifyError("Invalid HN !");
    }
  };

  const getPatient = async (hn) => {
    const ref = doc(db, "patients", hn);

    await getDoc(ref).then((item) => {
      setPatient(item.data());
    });
  };

  const getDoctors = async () => {
    const ref = collection(db, "doctors");

    const docSnap = await getDocs(ref);
    const temp = [];
    docSnap.forEach((item) => {
      temp.push(item.data());
    });
    setDoctorOptions(
      temp.filter((doctor) => {
        return doctor.status === "Available" && doctor.doctorType === "Other";
      })
    );
  };

  useEffect(() => {
    // Generate the sale order number when the component mounts
    generateId().then((id) => setSaleOrderNumber(id));
    getDoctors();
  }, []);

  return (
    <Fragment>
      <Toast />
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Order Form</h4>
            </div>
            <div className="card-body">
              <div className="form-validation">
                <form
                  className="form-valide"
                  action="#"
                  method="post"
                  onSubmit={handleSubmit}
                >
                  <div className="row">
                    <div className="col-xl-6">
                      <OrderForm
                        onChange={handleChange}
                        saleOrderNumber={saleOrderNumber}
                        fileNames={fileNames}
                        warrantyPeriod={inputRef.current.warrantyPeriod}
                        warrantyStart={startDate}
                        warrantyEnd={endDate}
                        receiptDate={receiptDate}
                      />
                      <br /> <br />
                      <div className="form-group row">
                        <div className="col-lg-8 ml-auto">
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                          <Link
                            to="/product-list"
                            type="submit"
                            className="btn btn-light ml-2"
                          >
                            Cancel
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      {orderStatuses.map((order, index) => (
                        <div
                          key={index}
                          className="d-flex align-items-center mb-1"
                        >
                          <div style={{ width: "120px" }}>
                            <Badge variant={order.variant}>
                              {order.status}
                            </Badge>
                          </div>
                          <div className="ms-3">
                            <span>{order.detail}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state, props) => ({
  cpap: selectCpaps(state.cpaps, { text: props.match.params.sn }),
});

const mapDispatchToProps = (dispatch) => ({
  startAddOrder: (order) => dispatch(startAddOrder(order)),
  startEditCpap: (id, updates) => dispatch(startEditCpap(id, updates)),
  startAddNote: (note, files) => dispatch(startAddNote(note, files)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductOrderRegister);
